import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import Dropdown from '../../components/Dropdown/Dropdown';
import { setActiveCompany } from '../../core/store/user/userSlice';
import { UserCompany } from '../../core/types';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ReactComponent as ArrowsIcon } from '../../icons/arrows.svg';
import './AggregatorDropdown.scss';

interface Props {
  className?: string;
}

export default function AggregatorDropdown({ className = '' }: Props) {
  const dispatch = useAppDispatch();
  const companies = useAppSelector((s) => s.user.companies);
  const activeCompany = useAppSelector((s) => s.user.activeCompany);

  let history = useHistory();

  const onClick = (company: UserCompany) => () => {
    if (company.company_id === activeCompany?.company_id) return;
    history.replace(history.location.pathname);
    dispatch(setActiveCompany(company));
  };

  return (
    <Dropdown
      data-testid='AggregatorDropdown'
      horizontalAlignment='left'
      className={`AggregatorDropdown mb-3 mx-n2 ${className}`}
      trigger={
        <>
          <span className='text-truncate text-start flex-grow-1 pe-1 fw-600'>
            {activeCompany?.name}
          </span>
          <ArrowsIcon className='flex-shrink-0' />
        </>
      }
      content={
        <>
          {companies.map((c) => (
            <button
              className={classNames(
                'd-block px-3 py-2 AggregatorDropdown__menuItem w-100 text-start',
                {
                  'AggregatorDropdown__menuItem--active':
                    c.company_id === activeCompany?.company_id,
                }
              )}
              key={c.company_id}
              onClick={onClick(c)}
            >
              {c.name}
            </button>
          ))}
        </>
      }
    />
  );
}
